/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Acquisitionmultiplicatorpersonposition3Inputs */

const de__field_acquisitionmultiplicatorpersonposition3 = /** @type {(inputs: _Field_Acquisitionmultiplicatorpersonposition3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiplikatorperson Rolle`)
};

/**

* @param {_Field_Acquisitionmultiplicatorpersonposition3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_acquisitionmultiplicatorpersonposition3 = /** @type {((inputs?: _Field_Acquisitionmultiplicatorpersonposition3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Acquisitionmultiplicatorpersonposition3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_acquisitionmultiplicatorpersonposition3(inputs)
});
export { _field_acquisitionmultiplicatorpersonposition3 as "_field_acquisitionMultiplicatorPersonPosition" }